import { memo } from 'react';

import WorkflowIconSVG from '@/assets/workflow-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IWorkflowIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={WorkflowIconSVG} {...props} />;

export const WorkflowIcon = memo(IWorkflowIcon) as typeof IWorkflowIcon;
